//import { accessTocken } from "./storage";

import axios from "axios";
import moment from "moment";

export const SERVER = "https://api.temx.org/api";
// export const SERVER = "http://65.108.157.242:8980/api";
export const SITEURL = "https://api.temx.org/";
export const expireToken = 100;
export const expireRefreshToken = 864000;

export function getWithOutAuth(url, params = {}) {
    const generatedUrl = new URL(SERVER + url);
    Object.keys(params).forEach(key => {
        if (params[key]) {
            generatedUrl.searchParams.append(key, params[key]);
        }
    });
    let status = null;
    return new Promise((resolve, reject) => {
        const header = {};

        fetch(generatedUrl, {
            method: "GET",
            headers: header
        })
            .then(function(response) {
                if (response.status === 403 || response.status === 401)
                    window.location.replace("/authorization/");

                status = response.status;
                return response.json();
            })
            .then(function(data) {
                resolve({ data, status });
            })
            .catch(err => {
                resolve({ data: null, status });
            });
    });
}

export function post(url, body, auth = true) {
    let status = null;
    return new Promise((resolve, reject) => {
        const header = {};
        if (
            auth &&
            localStorage.getItem("accessToken") &&
            localStorage.getItem("accessToken").length > 0
        ) {
            let lastRefresh = localStorage.getItem("tokenDate");
            if (
                lastRefresh &&
                Math.abs(moment(lastRefresh).diff(moment.utc(), "seconds")) >
                    expireToken
            ) {
                axios
                    .get(
                        `${SERVER}/User/Token/${localStorage.getItem(
                            "refToken"
                        )}`
                    )
                    .then(res => {
                        console.log(res.data.data);
                        localStorage.setItem(
                            "roles",
                            res.data.data.roles.toString()
                        );
                        localStorage.setItem(
                            "refToken",
                            res.data.data.refresh_token
                        );
                        localStorage.setItem(
                            "accessToken",
                            res.data.data.access_token
                        );
                        localStorage.setItem("tokenDate", moment.utc());
                        header["Content-Type"] = "application/json";
                        let token = localStorage.getItem("accessToken");
                        header.Authorization = "Bearer " + token;
                        fetch(SERVER + url, {
                            method: "POST",
                            headers: header,
                            body: JSON.stringify(body)
                        })
                            .then(function(response) {
                                if (
                                    response.status === 403 ||
                                    response.status === 401
                                )
                                    window.location.replace("/authorization/");

                                status = response.status;
                                return response.json();
                            })
                            .then(function(data) {
                                resolve({ data, status });
                            })
                            .catch(err => {
                                resolve({ data: null, status });
                            });
                    })
                    .catch(err => {
                        window.location.replace("/authorization/");
                        console.log(err);
                    });
            } else {
                header["Content-Type"] = "application/json";
                let token = localStorage.getItem("accessToken");
                header.Authorization = "Bearer " + token;
                fetch(SERVER + url, {
                    method: "POST",
                    headers: header,
                    body: JSON.stringify(body)
                })
                    .then(function(response) {
                        if (response.status === 403 || response.status === 401)
                            window.location.replace("/authorization/");

                        status = response.status;
                        return response.json();
                    })
                    .then(function(data) {
                        resolve({ data, status });
                    })
                    .catch(err => {
                        resolve({ data: null, status });
                    });
            }
        } else {
            header["Content-Type"] = "application/json";
            fetch(SERVER + url, {
                method: "POST",
                headers: header,
                body: JSON.stringify(body)
            })
                .then(function(response) {
                    if (response.status === 403 || response.status === 401)
                        window.location.replace("/authorization/");
                    status = response.status;
                    return response.json();
                })
                .then(function(data) {
                    resolve({ data, status });
                })
                .catch(err => {
                    resolve({ data: null, status });
                });
        }
    });
}

export function form(url, body) {
    let status = null;
    return new Promise((resolve, reject) => {
        const header = { "Content-Type": "application/json" };
        if (
            localStorage.getItem("token") &&
            localStorage.getItem("token").length > 0
        ) {
            axios
                .get(`${SERVER}/User/Token/${localStorage.getItem("token")}`)
                .then(res => {
                    console.log(res.data.data);
                    localStorage.setItem(
                        "roles",
                        res.data.data.roles.toString()
                    );
                    localStorage.setItem("token", res.data.data.refresh_token);
                    header.Authorization =
                        "Bearer " + res.data.data.access_token;
                    fetch(SERVER + url, {
                        method: "POST",
                        body: body,
                        headers: header
                    })
                        .then(function(response) {
                            status = response.status;
                            return response.json();
                        })
                        .then(function(data) {
                            resolve({ data, status });
                        })
                        .catch(err => {
                            resolve({ data: null, status });
                        });
                })
                .catch(err => {
                    window.location.replace("/authorization/");
                    console.log(err);
                });
        } else {
            fetch(SERVER + url, {
                method: "POST",
                body: body,
                headers: header
            })
                .then(function(response) {
                    status = response.status;
                    return response.json();
                })
                .then(function(data) {
                    resolve({ data, status });
                })
                .catch(err => {
                    resolve({ data: null, status });
                });
        }
    });
}

export function get(url, params = {}) {
    const generatedUrl = new URL(SERVER + url);
    Object.keys(params).forEach(key => {
        if (params[key]) {
            generatedUrl.searchParams.append(key, params[key]);
        }
    });
    let status = null;
    return new Promise((resolve, reject) => {
        const header = {};

        if (
            localStorage.getItem("accessToken") &&
            localStorage.getItem("accessToken").length > 0
        ) {
            let lastRefresh = localStorage.getItem("tokenDate");
            if (
                lastRefresh &&
                Math.abs(moment(lastRefresh).diff(moment.utc(), "seconds")) >
                    expireToken
            ) {
                axios
                    .get(
                        `${SERVER}/User/Token/${localStorage.getItem(
                            "refToken"
                        )}`
                    )
                    .then(res => {
                        console.log(res.data.data);
                        localStorage.setItem(
                            "roles",
                            res.data.data.roles.toString()
                        );
                        localStorage.setItem(
                            "refToken",
                            res.data.data.refresh_token
                        );
                        localStorage.setItem(
                            "accessToken",
                            res.data.data.access_token
                        );
                        localStorage.setItem("tokenDate", moment.utc());
                        header["Content-Type"] = "application/json";
                        let token = localStorage.getItem("accessToken");
                        header.Authorization = "Bearer " + token;
                        fetch(generatedUrl, {
                            method: "GET",
                            headers: header
                        })
                            .then(function(response) {
                                if (
                                    response.status === 403 ||
                                    response.status === 401
                                )
                                    window.location.replace("/authorization/");

                                status = response.status;
                                return response.json();
                            })
                            .then(function(data) {
                                resolve({ data, status });
                            })
                            .catch(err => {
                                resolve({ data: null, status });
                            });
                    })
                    .catch(err => {
                        window.location.replace("/authorization/");
                        console.log(err);
                    });
            } else {
                let token = localStorage.getItem("accessToken");
                header.Authorization = "Bearer " + token;
                header["Content-Type"] = "application/json";
                fetch(generatedUrl, {
                    method: "GET",
                    headers: header
                })
                    .then(function(response) {
                        if (response.status === 403 || response.status === 401)
                            window.location.replace("/authorization/");
                        status = response.status;
                        return response.json();
                    })
                    .then(function(data) {
                        resolve({ data, status });
                    })
                    .catch(err => {
                        resolve({ data: null, status });
                    });
            }
        } else {
            fetch(generatedUrl, {
                method: "GET",
                headers: header
            })
                .then(function(response) {
                    if (response.status === 403 || response.status === 401)
                        window.location.replace("/authorization/");

                    status = response.status;
                    return response.json();
                })
                .then(function(data) {
                    resolve({ data, status });
                })
                .catch(err => {
                    resolve({ data: null, status });
                });
        }
    });
}

export function responseValidator(status) {
    return status >= 200 && status < 300;
}
